<template>
  <div class="app-container">
    <el-page-header @back="goBack" content="失败详情"></el-page-header>
    <div class="app-table">
      <el-table
        ref="multipleTable"
        v-loading="listLoading"
        :data="list"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="100" />
        <el-table-column label="企业名称" property="uploadFileEntName" />
        <el-table-column
          label="社会统一信用代码"
          property="uploadFileCreditCode"
        />
        <el-table-column label="失败原因" property="reason" />
      </el-table>
      <!--翻页工具条-->
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="listQuery.current"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { queryRecordListDetail } from "@/common/api/entTag/entTag";
// import { getList } from '@/common/api/organization/group'
export default {
  name: "RoleManagement",
  data() {
    return {
      isShowUpload: false,
      list: [],
      total: 0,
      listQuery: {
        current: 1,
        size: 10,
        uploadFileDataId: "",
      },
    };
  },
  created() {
    this.listQuery.uploadFileDataId = this.$route.query.uploadFileDataId;
    if (this.listQuery.uploadFileDataId) this.queryRecordListDetail();
    this.setRem();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 查询列表
     */
    queryRecordListDetail() {
      this.listLoading = true;
      queryRecordListDetail({ ...this.listQuery }).then((response) => {
        const res = response.data;
        if (res.code == "000000") {
          this.list = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message({
            message: res.mesg,
            type: "error",
          });
        }
        this.listLoading = false;
      });
    },
    /**
     * 修改每页显示条数
     */
    handleSizeChange(val) {
      this.listQuery.size = val;
      this.queryRecordListDetail();
    },
    /**
     * 跳转到指定页
     */
    handleCurrentChange(val) {
      this.listQuery.current = val;
      this.queryRecordListDetail();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/common/styles/index.scss";
.shift-box {
  justify-content: space-between;
}
.drawer_upload {
  & >>> .el-upload-dragger {
    padding: 5px;
  }
}
</style>

